import React from 'react';
import {
  Grid,
  Typography,
  Button,
  TextField,
  InputAdornment,
  Box,
  // Button
} from '@mui/material';

const JobCategoryButton = (props) => {
  return (
    <div>
      <Button
        sx={{
          borderRadius: '6px',
          bgcolor: '#0B8238',
          fontSize: '10px',
          fontWeight: '400',
          '&:hover': {
            background: '#0B8238',
            opacity: 0.9,
          },
        }}
      >
        <Typography sx={{ color: 'white', fontSize: '11px', fontWeight: '500' }}>{props.data}</Typography>
      </Button>
    </div>
  );
};

export default JobCategoryButton;
